import React from 'react';
import {MultistoreLayoutType, OrderType, PlaceApi} from "../../../../services/Api/types";
import {ReactComponent as ClockIco} from "../../../../../images/icons/clock.svg";
import {ReactComponent as PinIco} from "../../../../../images/icons/pin-outline.svg";
import {ReactComponent as BasketIco} from "../../../../../images/icons/basket.svg";
import HoursHelper from "../../../../services/Menu/services/Availability/HoursHelper";
import DateService from "../../../../services/Common/Date/DateService";
import {useTranslation, withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {RootState} from "../../../../../reducers";
import {getSession} from "../../../../services/Session/reducer";

interface OwnProps {
    place: PlaceApi;
    layout: MultistoreLayoutType;
    withoutDeliveryInfo?: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MultistorePlaceCardFooter = ({place, layout, session, withoutDeliveryInfo}: Props) => {
    const {t} = useTranslation();
    const hours = place.hours || [];
    const isOpen = HoursHelper.isOpen(hours, DateService.now());
    const openingInfo = HoursHelper.getNextOpening(hours, DateService.now(), t);
    const isPaused = place.status === "PAUSED";

    const renderOrderInfo = () => {
        if (layout !== MultistoreLayoutType.HOME_WITH_MAP || withoutDeliveryInfo) return <></>;

        if (session.full_address && !place.in_delivery_zone && place.types.includes(OrderType.DELIVERY)) {
            return (
                <div className="place-card-footer-row">
                    <PinIco className="text-danger"/>
                    <p className="text-danger mb-0">{t("modules.multistore.field.your_address_is_not_available.title")}</p>
                </div>
            )
        }

        const texts: string[] = [];

        if (place.types.includes(OrderType.DELIVERY)) {
            if (place.delivery?.min_order_price) {
                texts.push(
                    `${t("modules.multistore.field.min_order_price.title")}: ${place.delivery.min_order_price}`
                );
            }

            if (place.delivery?.delivery_price) {
                texts.push(
                    `${t("enums.order.type.DELIVERY")}: ${place.delivery.delivery_price}`
                );
            }
        }

        if (texts.length === 0) return <></>;

        return (
            <div className="place-card-footer-row">
                <BasketIco className="text-muted"/>
                <p className="text-muted mb-0">{texts.join(" • ")}</p>
            </div>
        )
    }

    return (
        <div className="place-card-footer">
            {hours.length > 0 && !isPaused && (
                <div className="place-card-footer-row">
                    <ClockIco className={`${isOpen ? "text-success" : "text-danger"}`}/>
                    <p className={`${isOpen ? "text-success" : "text-danger"} mb-0`}>{openingInfo}</p>
                </div>
            )}
            {
                isPaused && (
                    <div className="place-card-footer-row">
                        <ClockIco className="text-warning"/>
                        <p className="text-warning mb-0">{t("common.word.temporarily_close")}</p>
                    </div>
                )
            }
            {renderOrderInfo()}
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session)
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MultistorePlaceCardFooter));